<template>
    <div class="app-body"
         id="view">
        <div class="padding">
            <el-tabs class="mt-4 tabs-pt-0"
                     type="card"
                     ref="tabs"
                     v-model="activeName"
                     @tab-click="handleClick">
                <el-tab-pane label="Plans"
                             name="plans">
                    <div class="box">
                        <div class="col-12">
                            <div class="no-effect">
                                <div class="box-body pt-0">
                                    <div v-on:mouseleave="tableLeave">
                                        <el-table :data="plans"
                                                  :default-sort="{prop: 'id', order: 'ascending'}"
                                                  class="w-full"
                                                  fit
                                                  stripe
                                                  @cell-mouse-enter="cellEnter">
                                            <el-table-column
                                                prop="id"
                                                label="Plan Id"
                                                :min-width="90"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="name"
                                                label="Name"
                                                :min-width="155"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="description"
                                                label="Description"
                                                :min-width="170"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="active"
                                                label="Active"
                                                :min-width="90"
                                                sortable>
                                                <template v-slot="scope">
                                                    <div class="text-center">
                                                        <span v-if="scope.row.active === 1"><i class="material-icons success">check</i></span>
                                                        <span v-else><i class="material-icons danger">close</i></span>
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="type"
                                                label="Type"
                                                :min-width="110"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span v-if="scope.row.type === 1">Pay As You Go</span>
                                                    <span v-else>Per Unit</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="price"
                                                label="Price"
                                                :min-width="110"
                                                :sort-method="priceSort"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.price | roundOff | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="term"
                                                label="Term"
                                                :min-width="110"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ getTermPeriodName(scope.row.term) }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="unlimited_inbound"
                                                label="Unlimited Inbound"
                                                :min-width="175"
                                                sortable>
                                                <template v-slot="scope">
                                                    <div class="text-center">
                                                        <span v-if="scope.row.unlimited_inbound === 1"><i class="material-icons success">check</i></span>
                                                        <span v-else><i class="material-icons danger">close</i></span>
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="unlimited_outbound"
                                                label="Unlimited Outbound"
                                                :min-width="185"
                                                sortable>
                                                <template v-slot="scope">
                                                    <div class="text-center">
                                                        <span v-if="scope.row.unlimited_outbound === 1"><i class="material-icons success">check</i></span>
                                                        <span v-else><i class="material-icons danger">close</i></span>
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_local_pn"
                                                label="Included Local PN"
                                                :min-width="165"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_tollfree_pn"
                                                label="Included Toll-free PN"
                                                :min-width="190"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_local_min"
                                                label="Included Local Min"
                                                :min-width="190"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.included_local_min }} min</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_tollfree_min"
                                                label="Included Toll-free Min"
                                                :min-width="190"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.included_tollfree_min }} min</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_local_sms"
                                                label="Included Local Texts"
                                                :min-width="190"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_tollfree_sms"
                                                label="Included Toll-free Texts"
                                                :min-width="200"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_short_code_sms"
                                                label="Included ShortCode Texts"
                                                :min-width="200"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_rvm"
                                                label="Included Voicemail"
                                                :min-width="180"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_amd"
                                                label="Included Machine Detection"
                                                :min-width="230"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_email"
                                                label="Included Email"
                                                :min-width="165"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_fax"
                                                label="Included Fax"
                                                :min-width="155"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_intl_call"
                                                label="Included International Calls"
                                                :min-width="230"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_intl_sms"
                                                label="Included International Texts"
                                                :min-width="230"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="included_users"
                                                label="Included Users"
                                                :min-width="155"
                                                sortable>
                                            </el-table-column>

                                            <template slot="empty"
                                                      class="text-center text-muted">
                                                <span v-if="plans.length === 0">No Data</span>
                                            </template>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="Rates"
                             name="rates">
                    <div class="box">
                        <div class="col-12">
                            <div class="no-effect">
                                <div class="box-body pt-0">
                                    <div v-on:mouseleave="tableLeave">
                                        <el-table :data="rates"
                                                  :default-sort="{prop: 'id', order: 'ascending'}"
                                                  class="w-full"
                                                  fit
                                                  stripe
                                                  @cell-mouse-enter="cellEnter">
                                            <el-table-column
                                                prop="id"
                                                label="Rate Id"
                                                :min-width="120"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="name"
                                                label="Rate Name"
                                                :min-width="120"
                                                sortable>
                                            </el-table-column>

                                            <el-table-column
                                                prop="default"
                                                label="Default"
                                                :min-width="100"
                                                sortable>
                                                <template v-slot="scope">
                                                    <div class="text-center">
                                                        <span v-if="scope.row.default === 1"><i class="material-icons success">check</i></span>
                                                        <span v-else><i class="material-icons danger">close</i></span>
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="local_pn"
                                                label="Local Phone Numbers"
                                                :min-width="200"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.local_pn | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="tollfree_pn"
                                                label="Toll-free Phone Numbers"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.tollfree_pn | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="local_min"
                                                label="Local Minutes"
                                                :min-width="155"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.local_min | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="tollfree_min"
                                                label="Toll-free Minutes"
                                                :min-width="175"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.tollfree_min | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="branded_call"
                                                label="Branded Calls"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.branded_call | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="enhanced_branded_call"
                                                label="Enhanced Branded Calls"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.enhanced_branded_call | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="local_sms"
                                                label="Local Text Messages"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.local_sms | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="tollfree_sms"
                                                label="Toll-free Text Messages"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.tollfree_sms | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="short_code_sms"
                                                label="ShortCode Text Messages"
                                                :min-width="210"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.short_code_sms | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="rvm"
                                                label="Ringless Voicemail"
                                                :min-width="175"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.rvm | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="lrn_lookup"
                                                label="LRN Lookup"
                                                :min-width="155"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.lrn_lookup | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="spam_lookup"
                                                label="Spam Lookup"
                                                :min-width="155"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.spam_lookup | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="amd"
                                                label="Automatic Machine Detection"
                                                :min-width="240"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.amd | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="email"
                                                label="Email"
                                                :min-width="155"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.email | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="fax"
                                                label="Fax"
                                                :min-width="155"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.fax | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="aloai_text_bot_enrollment"
                                                label="AloAi Agent Text Enrollment"
                                                :min-width="240"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.aloai_text_bot_enrollment | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="aloai_voice_bot_enrollment"
                                                label="AloAi Voice Bot Enrollment"
                                                :min-width="240"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.aloai_voice_bot_enrollment | fixRounding | toCurrency }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="intl_call_factor"
                                                label="International Call Factor"
                                                :min-width="220"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.intl_call_factor | fixRounding }}</span>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                prop="intl_sms_factor"
                                                label="International SMS Factor"
                                                :min-width="220"
                                                sortable>
                                                <template v-slot="scope">
                                                    <span>{{ scope.row.intl_sms_factor | fixRounding }}</span>
                                                </template>
                                            </el-table-column>

                                            <template slot="empty"
                                                      class="text-center text-muted">
                                                <span v-if="rates.length === 0">No Data</span>
                                            </template>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import auth from '../auth'
import {mapActions, mapState} from 'vuex'
import {acl_mixin} from "../../user/mixins"

export default {
    mixins: [
        acl_mixin,
    ],

    data() {
        return {
            auth: auth,
            activeName: 'plans'
        }
    },

    computed: {
        ...mapState(['plans', 'rates']),
    },

    beforeMount() {
        if (this.auth.user.profile.is_reseller) {
            this.$router.push({name: 'Dashboard'})
        }
    },

    mounted() {
        if (this.plans.length === 0) {
            this.getPlans()
        }

        if (this.rates.length === 0) {
            this.getRates()
        }

        if (this.$route.query.tab) {
            this.activeName = this.$route.query.tab
        }

        if (this.$refs.tabs) {
            this.$refs.tabs.$forceUpdate()
        }
    },

    methods: {
        getStyle(id) {
            let opacity = 0.5
            if (id == this.visible_row_id) {
                opacity = 1
            }

            return {
                opacity: opacity
            }
        },

        getPlans() {
            axios.get('/api/admin/plan', {
                params: {
                    all: true
                }
            }).then(res => {
                this.setPlans(res.data)
            })
        },

        getRates() {
            axios.get('/api/admin/rate?all=1')
                .then(res => {
                    this.setRates(res.data)
                })
        },

        handleClick(tab, event) {
            this.$router.push({name: 'Billing', query: {tab: tab.name}}).catch(err => {
            })
        },

        cellEnter: _.throttle(function (row, column, cell, event) {
            this.visible_row_id = row.id
        }, 50),

        tableLeave() {
            this.visible_row_id = null
        },

        priceSort(a, b) {
            return a.price - b.price
        },

        ...mapActions(['setPlans', 'setRates']),
    },

    watch: {
        $route({params, query}) {
            if (query.tab) {
                this.activeName = query.tab
            }
        },
    },


    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next()
            })
            .catch((err) => {
                next({name: 'Login', query: {redirect: to.fullPath}})
            })
    }
}
</script>
